const SHARED_SESSION_PREFIX = "valorant:riot:shared-session:v1:";
const SHARED_SESSION_VERSION = 1;

function normalizeUserId(value) {
    if (typeof value !== "number" && (typeof value !== "string" || !/^\d+$/.test(value))) return null;
    const userId = Number(value);
    return Number.isSafeInteger(userId) && userId > 0 ? userId : null;
}

function normalizePuuid(value) {
    return typeof value === "string" && value.trim() && value.trim().length <= 200
        ? value.trim() : null;
}

function sharedSessionKey(userId, puuid) {
    const normalizedUserId = normalizeUserId(userId);
    const normalizedPuuid = normalizePuuid(puuid);
    return normalizedUserId && normalizedPuuid
        ? `${SHARED_SESSION_PREFIX}${normalizedUserId}:${encodeURIComponent(normalizedPuuid)}` : null;
}

function normalizeToken(value) {
    if (typeof value !== "string" || !value.trim()) return null;
    try {
        return decodeURIComponent(value.trim());
    } catch (error) {
        return null;
    }
}

function normalizeSession(value, userId, puuid) {
    if (!value || typeof value !== "object" || Array.isArray(value)) return null;
    if (normalizeUserId(value.userId) !== userId || normalizePuuid(value.puuid) !== puuid) return null;
    const accessToken = normalizeToken(value.accessToken);
    const entitlementsToken = normalizeToken(value.entitlementsToken);
    if (!accessToken || !entitlementsToken) return null;
    if (value.loginMode !== "ApiMode" && value.loginMode !== "VShopMode") return null;
    return {
        userId,
        puuid,
        accessToken,
        entitlementsToken,
        headersCookie: typeof value.headersCookie === "string" ? value.headersCookie.trim() : "",
        loginMode: value.loginMode,
    };
}

function readSharedSession(storage, userId, puuid) {
    const key = sharedSessionKey(userId, puuid);
    if (!key || !storage || typeof storage.getItem !== "function") return null;
    let value;
    try {
        const raw = storage.getItem(key);
        if (!raw) return null;
        value = JSON.parse(raw);
    } catch (error) {
        return null;
    }
    if (!value || value.version !== SHARED_SESSION_VERSION) return null;
    const session = normalizeSession(value, normalizeUserId(userId), normalizePuuid(puuid));
    if (!session || !Number.isSafeInteger(value.updatedAt) || value.updatedAt <= 0
        || !Number.isSafeInteger(value.operationStartedAt) || value.operationStartedAt <= 0) return null;
    return {
        version: SHARED_SESSION_VERSION,
        ...session,
        updatedAt: value.updatedAt,
        operationStartedAt: value.operationStartedAt,
        ...((value.diagnosticPublisher === "shop" || value.diagnosticPublisher === "record")
            ? { diagnosticPublisher: value.diagnosticPublisher } : {}),
    };
}

function publishSharedSession(storage, context) {
    if (!context || !storage || typeof storage.setItem !== "function") return false;
    const userId = normalizeUserId(context.userId);
    const puuid = normalizePuuid(context.puuid);
    const key = sharedSessionKey(userId, puuid);
    if (!key) return false;
    const session = normalizeSession({ ...context.session, userId }, userId, puuid);
    const operationStartedAt = context.operationStartedAt;
    const now = context.now === undefined ? Date.now() : context.now;
    if (!session || !Number.isSafeInteger(operationStartedAt) || operationStartedAt <= 0
        || !Number.isSafeInteger(now) || now <= 0 || now < operationStartedAt) return false;
    try {
        if (context.isCurrent && !context.isCurrent()) return false;
        const previous = readSharedSession(storage, userId, puuid);
        if (context.onlyIfAbsent && previous) return false;
        if (previous && previous.operationStartedAt > operationStartedAt) return false;
        if (context.isCurrent && !context.isCurrent()) return false;
        storage.setItem(key, JSON.stringify({
            version: SHARED_SESSION_VERSION,
            ...session,
            headersCookie: session.headersCookie || (previous && previous.headersCookie) || "",
            updatedAt: now,
            operationStartedAt,
            ...(process.env.VUE_APP_DEPLOY_ENV === "test"
                && (context.publisher === "shop" || context.publisher === "record")
                ? { diagnosticPublisher: context.publisher } : {}),
        }));
        return true;
    } catch (error) {
        return false;
    }
}

module.exports = {
    readSharedSession,
    publishSharedSession,
    sharedSessionKey,
};
